import MachineLabsPage from "@/components/machine-labs/MachineLabsPage.vue";
import MachineLabPage from "@/components/machine-labs/MachineLabPage.vue";

const machineLabsRoutes = [{
    path: '/machine-labs',
    component: MachineLabsPage,
    meta: {
        requiresAuth: false, // Allow public access to browse machine labs
        title: "Machine Labs | Akademi Siber"
    },
},
{
    path: '/machine-labs/:id',
    component: MachineLabPage,
    meta: {
        requiresAuth: true, // Require auth for accessing specific machine lab
        title: "Machine Labs | Akademi Siber"
    },
}
];

export default machineLabsRoutes;